import _ from 'underscore';
import xtend from 'xtend';
import mxtend from 'xtend/mutable';
import inherits from 'inherits';
import format from 'date-fns/format';
import parse from 'date-fns/parse';
import addWeeks from 'date-fns/add_weeks';
import subWeeks from 'date-fns/sub_weeks';
import isWithinRange from 'date-fns/is_within_range';
import { endOfDay, startOfDay } from 'date-fns'
import moment from 'moment'
import Store from '@nichoth/state';

import { getContentGroupData } from '../../../redux/data/selectors';

import reduxStore from '../../../redux/store'
import { DATE_FORMATS } from '../../../utils/Formatter';

var SEARCH_FIELDS = ['title', 'description', 'anyCategories', 'location',
    'keywords', 'eventID', 'customID'];

export const getDefaults = (reduxState) => {
    if (!reduxState) {
        reduxState = reduxStore.getState()
    }
    return {
        anyCategories: getContentGroupData(reduxState).categories.map(category => category.categoryID),
        startDateTime: startOfDay(moment(subWeeks(new Date(), 2)).format(DATE_FORMATS.apiDateFormat)),
        stopDateTime: endOfDay(moment(addWeeks(new Date(), 2)).format(DATE_FORMATS.apiDateFormat)),
        getOnlyPrivate: false,
        resultMax: 10,
        liveOnly: false,
        showEncoder: true,
        showMediaAssets: true,
        showMediaDetails: true,
        showStreams: true,
        sortBy: 'DESC',
        totalPages: null,
        currentPage: null,
        search: {}
    }
}

function EventsQueryStore (args) {
    if (!(this instanceof EventsQueryStore)) return new EventsQueryStore(args);
    Store.call(this, args);
}
inherits(EventsQueryStore, Store);

mxtend(EventsQueryStore.prototype, {
    _state: function (state) {
        state = state || {};
        var _state = xtend(getDefaults(), state);
        if (_state.resultPage) _state.currentPage = _state.resultPage;
        var s = _.pick(_state, Object.keys(getDefaults()));
        s.search = _.pick(state, SEARCH_FIELDS);
        return s;
    },

    onlyPrivate: function (value) {
        this._state.getOnlyPrivate = value;
        return this.publish();
    },

    set: function (data) {
        mxtend(this._state, _.pick(data, Object.keys(getDefaults()) ));
        return this.publish();
    },

    setFromRequest: function (req) {
        var state = _.pick(req.body, Object.keys(getDefaults()));
        if (state.startDateTime) state.startDateTime = parse(state.startDateTime);
        if (state.stopDateTime) state.stopDateTime = parse(state.stopDateTime);
        mxtend(this._state, state, {
            liveOnly: req.body.getLive === undefined ?
                false :
                req.body.getLive,
            totalPages: req.totalPages,
            currentPage: req.currentPage,
            search: _.pick(req.body, SEARCH_FIELDS)
        });
        return this.publish();
    },
});

EventsQueryStore.isWithinQuery = function (state, event) {
    var evStart = parse(event.startDateTime);
    if (state.startDateTime > state.stopDateTime) return false
    return (isWithinRange(evStart, state.startDateTime, state.stopDateTime) &&
        (state.getOnlyPrivate ? event.private : true));
};

// get rid of any search fields when you use this function
EventsQueryStore.getParams = function (state, params) {
    state = reduxStore.getState().events.filters
    var _state = xtend(state, {
        startDateTime: format(state.startDateTime, 'YYYY-MM-DD'),
        stopDateTime: format(state.stopDateTime, 'YYYY-MM-DD')
    }, params);
    if (!_state.anyCategories || _state.anyCategories.length == 0) {
        _state.anyCategories = getContentGroupData(reduxStore.getState()).categories.map(category => category.categoryID)
    }
    if (_state.eventID) return { eventID: _state.eventID };
    if (_state.cutomID) return { customID: _state.cutomID };

    if (_state.currentPage && _state.currentPage != 1) _state.resultPage =
        _state.currentPage;

    delete _state.currentPage;
    delete _state.totalPages;
    delete _state.search;

    if (_state.liveOnly) _state.getLive = true;
    delete _state.liveOnly;

    if (_state.getOnlyPrivate) {
        _state.getOnlyPrivate = _state.getOnlyPrivate == true
    }

    // messy search params
    if (Object.keys(state.search).length) {
        mxtend(_state, state.search);
    }

    // empty description doesn't match any events
    if (_state.description === '') {
        delete _state.description
    }

    // anyCategories must be an array
    if (_state.anyCategories && !Array.isArray(_state.anyCategories)) {
        _state.anyCategories = [_state.anyCategories]
    }

    return _state;
    // return _.omit(_state);
};

EventsQueryStore.getParams.search = function (state, search) {
    if (search.eventID) return { eventID: search.eventID };
    if (search.customID) return { customID: search.customID };
    var params = _.omit(EventsQueryStore.getParams(state, {}), SEARCH_FIELDS);
    return xtend(params, search);
};

EventsQueryStore.getParams.page = function (state, pageNumber) {
    return xtend(EventsQueryStore.getParams(state), {
        resultPage: pageNumber
    });
};

EventsQueryStore.SEARCH_FIELDS = SEARCH_FIELDS;

export default EventsQueryStore;
